import React, { useState } from "react";

//* Import components from react-bootstrap
import { Form, InputGroup } from "react-bootstrap";

//! Import custom components
import { TableDrag } from "../TableDrag";
import ModalManage from "../../QuestionsView/list/components/ModalManage";

//? Import types
import { QuestionItem } from "./types/types";
import { QuestionDetailsWithOriginalType } from "../form/index";

type ExamSelectedQuestionsProps = {
  questionsArray: QuestionItem[];
  setQuestionsArray: React.Dispatch<React.SetStateAction<QuestionItem[]>>;
  questions: QuestionDetailsWithOriginalType[];
  setQuestions: React.Dispatch<
    React.SetStateAction<QuestionDetailsWithOriginalType[]>
  >;
  token: string;
  editMode?: boolean;
  accumulatedQuestionsRef: React.MutableRefObject<QuestionDetailsWithOriginalType[]>;
};

/**
 * ExamSelectedQuestions component.
 *
 * @param {ExamSelectedQuestionsProps} props - The props for the component.
 * @returns {JSX.Element} The rendered component.
 */
const ExamSelectedQuestions: React.FC<ExamSelectedQuestionsProps> = ({
  questionsArray,
  setQuestionsArray,
  questions,
  setQuestions,
  token,
  editMode,
  accumulatedQuestionsRef,
}) => {
  const [selectedQuestionId, setSelectedQuestionId] = useState<string | null>(
    null
  );
  const [showModalManage, setShowModalManage] = useState<boolean>(false);

  // Exibe os detalhes da questão
  const handleShowData = (index: number) => {
    const questionId = questionsArray[index].id;
    setSelectedQuestionId(questionId);
    setShowModalManage(true);
  };

  // Remove uma questão das selecionadas
  const handleDeleteData = (index: number) => {
    const questionId = questionsArray[index].id;
    const updatedQuestions = questions.filter((q) => q.id !== questionId);
    const updatedQuestionsArray = questionsArray.filter(
      (item) => item.id !== questionId
    );
    setQuestions(updatedQuestions);
    setQuestionsArray(updatedQuestionsArray);
    accumulatedQuestionsRef.current = updatedQuestions;
  };

  // Atualiza as questões selecionadas (para o TableDrag)
  const handleSetData: React.Dispatch<React.SetStateAction<QuestionItem[]>> = (
    updatedData
  ) => {
    if (typeof updatedData === "function") {
      setQuestionsArray((prev) => updatedData(prev));
    } else {
      setQuestionsArray(updatedData);
    }
  };

  return (
    <>
      <Form.Label>Questões selecionadas</Form.Label>
      <br />
      <Form.Label>
        Total:{" "}
        <span style={{ fontWeight: "normal" }}>
          {questions.length} {questions.length === 1 ? "questão" : "questões"}
        </span>
      </Form.Label>

      <InputGroup>
        <TableDrag
          draggable={!editMode}
          data={questionsArray}
          showData={handleShowData}
          deleteData={handleDeleteData}
          setData={handleSetData}
        />
      </InputGroup>

      <ModalManage
        id={selectedQuestionId}
        token={token}
        showModalManage={showModalManage}
        setShowModalManage={() => setShowModalManage(false)}
      />
    </>
  );
};

export default ExamSelectedQuestions;
